package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

object GameTableValidator {

    fun validateName(name: String): Result<Unit> {
        return if (name.isBlank()) {
            Result.failure(ValidationError("Table name cannot be empty"))
        } else {
            Result.success(Unit)
        }
    }
}
